import Page from "../../../../components/Layout/Page";
import { useIsMobile } from "../../../../helpers/ui";
import { colors } from "../../../../styles";
import { DesktopHeader, MobileHeader } from "../Account/components";
import { employeeAccountPath } from "../../../../routes/paths";
import HeaderBreadcrumbs from "../../../../components/HeaderBreadcrumbs";
import T from "../../../../components/Typography";
import ResponsePageContent from "../../../../components/Layout/ResponsivePageContent";
import { useNavigate } from "react-router-dom";
import { SectionFlexColumn } from "../../../../components/General";
import {
  SettingsSection,
  SettingHeader,
  SettingsItem,
} from "../Settings/components";
import useGetAccount from "../../../../hooks/queries/employee/useGetAccount";
import Loader from "../../../../components/Loader";
import {
  DebitCardConstants,
  showDebitCardFeature,
} from "../../../../helpers/debitcard";
import ErrorPage from "../../../../components/ErrorPage";
import {
  ChangeAddressSetting,
  ChangePinSetting,
  DebitCardEnabledSetting,
  OrderNewCardSetting,
} from "./components";

const DebitCardInfo = () => {
  const { data, status } = useGetAccount();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const title = "Debit Card";
  const subtitle = "Learn more about your card";
  const breadcrumbs = ["My Account", title];

  if (status === "loading") return <Loader />;
  if (status === "error") return <ErrorPage />;

  const doBack = () => {
    navigate(employeeAccountPath);
  };

  const renderFeatureDisabled = () => {
    return (
      <div>
        <T variant="lgReg" color={colors.red}>
          Debit cards are not enabled for your program.
        </T>
      </div>
    );
  };

  const featureEnabled = showDebitCardFeature(
    data.challenger_saving.debit_card
  );

  return (
    <Page>
      {isMobile ? (
        <MobileHeader
          title={title}
          showBack
          showClose
          handleBack={doBack}
          closeRoutePath={employeeAccountPath}
        />
      ) : (
        <DesktopHeader>
          <HeaderBreadcrumbs breadcrumbs={breadcrumbs} handleBack={doBack} />
        </DesktopHeader>
      )}
      <ResponsePageContent title={title} subtitle={subtitle}>
        {featureEnabled ? (
          <SectionFlexColumn>
            <SettingsSection>
              <SettingHeader title="Info" />
              <SettingsItem
                title="ATM Withdrawal Limit"
                subtitle="$2,000 Per Month"
                rightSide={
                  <T variant="mdReg" color={colors.gray_600}>
                    {DebitCardConstants.ATM_WITHDRAWAL_DAILY_LIMIT}
                  </T>
                }
              />
              <SettingsItem
                title="Card Spending Limit"
                rightSide={
                  <T variant="mdReg" color={colors.gray_600}>
                    {DebitCardConstants.CARD_SPEND_DAILY_LIMIT}
                  </T>
                }
                showBottomBottomBorder={false}
              />
            </SettingsSection>
            <SettingsSection>
              <SettingHeader title="Actions" />
              <DebitCardEnabledSetting
                data={data.challenger_saving.debit_card}
              />
              <OrderNewCardSetting />
              <ChangePinSetting data={data.challenger_saving.debit_card} />
              <ChangeAddressSetting />
            </SettingsSection>
          </SectionFlexColumn>
        ) : (
          renderFeatureDisabled()
        )}
      </ResponsePageContent>
    </Page>
  );
};

export default DebitCardInfo;
